import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1145a1e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "complaint-layout"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "good-title"
}, [/*#__PURE__*/_createElementVNode("h4", null, "商品质量等相关投诉说明")], -1));
const _hoisted_3 = {
  class: "good-item-title"
};
const _hoisted_4 = {
  class: "van-cell__label",
  style: {
    "text-align": "left"
  }
};
const _hoisted_5 = {
  style: {
    "margin": "20px"
  }
};
import { onMounted } from "vue";
export default {
  __name: 'ComplaintGoodComponents',
  setup(__props) {
    onMounted(() => {
      document.title = '商品质量等相关投诉说明';
    });
    const list = [{
      title: '二维码和条形码生成器是什么',
      content: '二维码和条形码生成器是一个二维码制作工具，免费提供二维码生成与管理。',
      line: true
    }, {
      title: '二维码是谁做的',
      content: '二维码由商家自行制作。商家会上传图片、文字等内容，生成二维码。通常是为了展示商品信息、做电子说明书等用途。',
      line: true
    }, {
      title: '我的售后怎么办',
      content: '商量质量或者售后问题，二维码和条形码生成器无法解决，请您与商品生产方或销售方联系。如有需要，您可以向有关部门进行投诉反馈，我们会配合有关部门提供必要信息。',
      line: true
    }, {
      title: '有关部门联系方式',
      content: '消费者协会电话：12315',
      line: false
    }];
    const submit = () => {
      window.location.href = 'tel:12315';
    };
    return (_ctx, _cache) => {
      const _component_van_divider = _resolveComponent("van-divider");
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, item => {
        return _createElementVNode("div", {
          class: "good-item-layout",
          key: item
        }, [_createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(item.content), 1), _withDirectives(_createVNode(_component_van_divider, {
          style: {
            "background-color": "rgb(169, 169, 169, 0.4)"
          }
        }, null, 512), [[_vShow, item.line]])]);
      }), 64)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
        type: "success",
        block: "",
        onClick: submit
      }, {
        default: _withCtx(() => [_createTextVNode("立即拨打12315")]),
        _: 1
      })])]);
    };
  }
};